var _defs, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUntitledDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "de0e6b14c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 0 C 83.945312 0 0 83.945312 0 187.5 C 0 291.054688 83.945312 375 187.5 375 C 291.054688 375 375 291.054688 375 187.5 C 375 83.945312 291.054688 0 187.5 0 Z M 187.5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4f7e6a5626"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 143.679688 143.679688 L 232.160156 143.679688 L 232.160156 232.160156 L 143.679688 232.160156 Z M 143.679688 143.679688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "95bc05214c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.917969 143.679688 C 163.484375 143.679688 143.679688 163.484375 143.679688 187.917969 C 143.679688 212.351562 163.484375 232.160156 187.917969 232.160156 C 212.351562 232.160156 232.160156 212.351562 232.160156 187.917969 C 232.160156 163.484375 212.351562 143.679688 187.917969 143.679688 Z M 187.917969 143.679688 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de0e6b14c3)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 0.0000045, 0)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 249.999994 0 C 111.927078 0 -0.000006 111.927084 -0.000006 250 C -0.000006 388.072917 111.927078 500.000001 249.999994 500.000001 C 388.072911 500.000001 499.999995 388.072917 499.999995 250 C 499.999995 111.927084 388.072911 0 249.999994 0 Z M 249.999994 0 ",
    stroke: "#000000",
    strokeWidth: 30,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3131",
    d: "M 187.496094 88.480469 C 133.035156 88.480469 88.480469 133.035156 88.480469 187.496094 C 88.480469 241.957031 133.035156 286.515625 187.496094 286.515625 C 241.957031 286.515625 286.515625 241.957031 286.515625 187.496094 C 286.515625 133.035156 241.957031 88.480469 187.496094 88.480469 Z M 187.496094 229.933594 C 164.15625 229.933594 145.058594 210.835938 145.058594 187.496094 C 145.058594 164.15625 164.15625 145.058594 187.496094 145.058594 C 210.835938 145.058594 229.933594 164.15625 229.933594 187.496094 C 229.933594 210.835938 210.835938 229.933594 187.496094 229.933594 Z M 187.496094 229.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4f7e6a5626)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#95bc05214c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff3131",
    d: "M 143.679688 143.679688 L 232.160156 143.679688 L 232.160156 232.160156 L 143.679688 232.160156 Z M 143.679688 143.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntitledDesign);
export default __webpack_public_path__ + "static/media/Untitled-design.f06ab103862dd78d917ec1af4b8824ed.svg";
export { ForwardRef as ReactComponent };